import posthog from "posthog-js";
import { mPosthogPublicApiKey, mPosthogPublicHost, mPosthogUIHost } from "@/config/posthog";

const _posthog = posthog.init(mPosthogPublicApiKey, {
  api_host: mPosthogPublicHost,
  ui_host: mPosthogUIHost,
  defaults: "2025-05-24",
  person_profiles: "identified_only",
});

export { _posthog as posthog };
